import React, { useEffect } from "react";

import useCall from "../../hooks/useCall";
import Call from "./Call";
import { Box, Stack, Typography } from "@mui/material";

const Calls = ({ filter, onRefresh }) => {
  const { getCalls, calls } = useCall();

  useEffect(() => {
    getData();
  }, [filter]);

  const getData = async () => {
    getCalls(filter, { field: "scheduleDate", direction: "asc" });
  };

  const handleRefresh = async () => {
    await getData();
    onRefresh();
  };

  return (
    <Box sx={{ padding: "10px" }}>
      {Array.isArray(calls) && calls.length > 0 ? (
        <Stack spacing={1}>
          {calls.map((call) => (
            <Call
              call={call}
              showDate
              showProject
              onRefresh={handleRefresh}
            />
          ))}
        </Stack>
      ) : (
        <Typography>No Calls Found</Typography>
      )}
    </Box>
  );
};

export default Calls;
